import type { HttpClient } from '@shared/api/http'

const BOOKING_EMBED_CLICKED = 'booking_embed_clicked'
const USER_ID_PREFIX = 'usr_'

function normalizeProviderId(providerId: string): string {
  return providerId.startsWith(USER_ID_PREFIX) ? providerId : `${USER_ID_PREFIX}${providerId}`
}

export function createBookingAnalyticsService(
  httpClient: HttpClient,
  baseUrl: string,
): {
  trackBookingEmbedClicked: (userId: string, properties: Record<string, unknown>) => Promise<void>
} {
  const url = `${baseUrl}/analytics/track-booking`
  return {
    async trackBookingEmbedClicked(userId, properties) {
      const normalizedUserId = normalizeProviderId(userId)
      return httpClient<void>(url, 'post', {
        body: { userId: normalizedUserId, event: BOOKING_EMBED_CLICKED, properties },
      })
    },
  }
}
